/**
 * Created by tomers on 2/28/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/conversation-sources/conversationSourcesGalleryView.tmpl");

    var ConversationSourcesGalleryComponent = require("ui.components/gallery/ConversationSourcesGallery");
    var Ellipsis = require("ui.plugins/ellipsis");

    var ConversationSourcesGalleryView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        ConversationSourcesGalleryView = Marionette.ItemView.extend({
            template: template,
            className: "conversation-sources-gallery-view",
            ui: {
                galleryContainer: ".gallery-container"
            },
            uiComponents: {
                gallery: {
                    type: ConversationSourcesGalleryComponent,
                    options: {
                        collection: "view.collection",
                        collectionMap: {
                            "isEditable": "isEditable",
                            "key": "id"
                        },
                        el: "view.ui.galleryContainer",
                        selectableGallery: false
                    },
                    events: {
                        "click": "_onGalleryItemClick",
                        "edit": "_onGalleryItemClick",
                        "view": "_onGalleryItemClick"
                    }
                }
            },

            initialize: function (options) {
                this.channel = LEManager.media.channel("conversationSources");
                this.collection = LEManager.getModuleDataManager().getData(LEManager.getModuleDataManager().getEntities().CONVERSATION_SOURCES_GALLERY);
            },

            onRender: function () {

                //we either do it here with deferred or on show( since the view can not know the parent is using region Show we do it here )
                _.defer(_.bind(function(){
                    Ellipsis.handleNow(this);
                }, this));

            },

            _onGalleryItemClick: function(componentId, eventName, conversationSourceId) {
                LEManager.logger.info("Edit gallery item clicked", "ConversationSourcesGalleryView:_onGalleryItemClick");
                var model = this.collection.get(conversationSourceId);
                var path = model ? model.getPath() : "";
                this.channel.trigger("gallery:itemClick", path);
            }
        });

    }

    LE.module("LEManager", moduleDefinition);

    return ConversationSourcesGalleryView;
});
